import { z } from 'zod';

export const basePatientSchema = z.object({
  id: z.guid(),
  firstName: z.string().min(1, 'First name is required'),
  lastName: z.string().min(1, 'Last name is required'),
  dateOfBirth: z.union([z.string(), z.number()]),
  email: z.string().nullable(),
  phone: z.string().optional().nullable(),
  address: z.string(),
  city: z.string(),
  country: z.string(),
  postalCode: z
    .union([
      z
        .string()
        .regex(
          /^(?:[A-Za-z]\d[A-Za-z][ -]?\d[A-Za-z]\d|\d{5}(?:-\d{4})?)$/,
          'Invalid postal or ZIP code'
        ),
      z.literal(''),
    ])
    .optional()
    .nullable(),
  sex: z.string().min(1, 'Sex is required'),
  maritalStatus: z.string(),
  province: z
    .string()
    .regex(/AB|BC|MB|NB|NL|NS|NT|NU|ON|PE|QC|SK|YT/, 'Invalid province'),
  searchVector: z.string().nullable(),
  organizationID: z.guid().nullable(),
});

export const patientSummarySchema = basePatientSchema
  .pick({
    id: true,
    firstName: true,
    lastName: true,
  })
  .strict();
